import React, { useContext } from "react";
import "./sideBar.scss";
import { IoSettingsOutline } from "react-icons/io5";
import { MdOutlineLogout } from "react-icons/md";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { SiReasonstudios } from "react-icons/si";
import { FaBoxOpen } from "react-icons/fa";
import { FaCartShopping } from "react-icons/fa6";
import axios from "axios";
import { FaCartPlus } from "react-icons/fa";
import { AiOutlineProduct } from "react-icons/ai";
import { TiHome } from "react-icons/ti";
import { FaCalendarDays } from "react-icons/fa6";
import { BsChatQuoteFill } from "react-icons/bs";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import { FaCreditCard } from "react-icons/fa";
import { IoWalletSharp } from "react-icons/io5";
import { FaAward } from "react-icons/fa";
import { FaChartLine } from "react-icons/fa";
import { GiBookCover } from "react-icons/gi";
import { GiNotebook } from "react-icons/gi";
import { RiUserSettingsFill } from "react-icons/ri";
import { AiFillProduct } from "react-icons/ai";
import { IoMdBookmarks } from "react-icons/io";
import { FaUser } from "react-icons/fa";

const SideBar = () => {
  const navigate = useNavigate();
  const { user, dispatch } = useContext(AuthContext);

  const logoutUser = async () => {
    const controller = new AbortController();
    const signal = controller.signal;
    try {
      await axios.get("/admin-logout");
      localStorage.removeItem("user");
      dispatch({ type: "LOGOUT" });
      navigate("/");
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled", error.message);
      } else {
        console.error("Error fetching data:", error);
      }
    }
    return () => controller.abort();
  };
  return (
    <div className="sideBar_wrp">
      <div className="sideBar_in">
        <div className="sideBar_top">
          <img src={require("../../img/logo.png")} alt="" />
        </div>
        <div className="sideBar_center">
          <ul>
            <NavLink
              to="/dashboard"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <TiHome size={20} /> <small>Home</small>
              </li>
            </NavLink>

            <NavLink
              to="/products"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <FaCartShopping size={17} /> <small>Products</small>
              </li>
            </NavLink>

            <NavLink
              to="/customer
"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <FaUser size={17} /> <small>Customer</small>
              </li>
            </NavLink>

            <NavLink
              to="/orders
"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <FaBoxOpen size={17} /> <small>Orders</small>
              </li>
            </NavLink>

            <NavLink
              to="/add-products"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <FaCartPlus size={17} /> <small>Add Products</small>
              </li>
            </NavLink>
            <NavLink
              to="/categories"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <AiFillProduct size={17} /> <small>Categories</small>
              </li>
            </NavLink>

            <NavLink
              to="/brands"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <IoMdBookmarks size={17} /> <small>Add Brands</small>
              </li>
            </NavLink>

            {/* <NavLink
              to="/invoices"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <FaFileInvoiceDollar size={17} /> <small>Invoices</small>
              </li>
            </NavLink> */}

            {/* <NavLink
              to="/my-wallet"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <IoWalletSharp size={17} /> <small>My Wallet</small>
              </li>
            </NavLink> */}

            {/* <NavLink
              to="/rewards"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <FaAward size={17} /> <small>Rewards</small>
              </li>
            </NavLink> */}

            {/* <NavLink
              to="/reports"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              <li>
                <FaChartLine size={17} /> <small>Reports</small>
              </li>
            </NavLink> */}
          </ul>
        </div>
        <div className="sideBar_bottom">
          {/* <span>
            <IoSettingsOutline />
          </span> */}
          <span onClick={logoutUser}>
            <MdOutlineLogout fontSize={20} />
            <small>Logout</small>
          </span>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
